import React from 'react'
// ##
import PackagesTable from '../../modules/Package/components/PackagesTable'

export default function PackagePage() {
  return <PackagesTable />
}
